import apiClient from './apiClient'

export const getAllWorkingRegimes = user => apiClient.get(user, 'api/working-regimes')
